<template>
  <EntityList
    ref="activeList"
    :config="config"
    :columns="columns"
    :custom-query="{ poll: parentEntity.id }"
    :formatted-columns="formattedColumns"
    :form-fields="formFields"
    authority="Poll_Management_Poll"
    embedded
    @entityUpdated="updateEntity"
  />
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'
import storeModule from './questionsStoreModule'

export default {
  components: {
    EntityList,
  },
  props: {
    module: {
      type: String,
      required: true,
    },
    parentEntity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      entity: {},
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'poll-questions',
        endpoint: 'poll-questions',
        route: 'poll-questions',
        title: {
          single: this.$t('Question Add'),
          plural: this.$t('Questions'),
        },
      }
    },
    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'title', label: this.$t('title'), sortable: true },
        { key: 'ordering', label: this.$t('ordering'), sortable: true },
        {
          key: 'creationDate',
          label: this.$t('Creation Date'),
          sortable: true,
        },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formattedColumns() {
      return [{ key: 'creationDate', type: 'datetime' }]
    },
    formFields() {
      return [
        {
          id: 'poll',
          type: 'hidden',
          initVal: { id: this.parentEntity.id },
          hidden: true,
        },
        {
          id: 'title',
          type: 'text',
          label: this.$t('title'),
          required: true,
        },
        {
          id: 'options',
          type: 'selectmultiple',
          label: this.$t('Options'),
          object: true,
          options: [],
          taggable: true,
          pushTags: true,
          colSize: 12,
        },
        {
          id: 'optionsCnt',
          type: 'text',
          label: this.$t('optionsCnt'),
          required: true,
          rules: 'integer',
          initVal: 1,
          colSize: 6,
        },
        {
          id: 'ordering',
          type: 'text',
          label: this.$t('ordering'),
          required: true,
          rules: 'integer',
          initVal: 1,
          colSize: 3,
        },
        {
          id: 'enabled',
          type: 'checkbox',
          label: this.$t('enabled'),
          initVal: true,
          colSize: 3,
        },
        {
          id: 'description',
          type: 'quill',
          label: this.$t('description'),
          required: false,
        },
      ]
    },
  },
  mounted() {
    this.loaded = true
  },
  methods: {
    updateEntity(newEntity) {
      this.entity = newEntity
    },
  },
}
</script>
